import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loadingState: false,
        token: null,
        user: null,
        attachmenttypes: null,
        inheritance: null,
        inheritanceFlow: null,
        operators: null,
        message: null,
        vats: null,
        isStaging: false
    },
  mutations: {
    changeLoadingState(state, { value }) {
      state.loadingState = value;
    },
    // 🎈 @mattia qui c'è la logica per l'autenticazione
      authUser(state, { user }) {
          state.token =user.token;
          state.user = user;
         
        localStorage.setItem('nb-succ-api', JSON.stringify(user));
          axios.defaults.headers['Authorization'] = `Bearer ${state.token}`;

    },
      clearAuth(state) {
          state.token = null;
          state.user = null;
          localStorage.removeItem('nb-succ-api');
          axios.defaults.headers['Authorization'] = null;
      }
      ,
       setEnvironment(state, isstaging) {
          this.state.isStaging = isstaging
      }
     
  },
    actions: {

        login({ commit }, { username, password }) {
            var theToken = null;
            return axios
                .post('user/authenticate', {
                    username: username,
                    password: password
                })
        },
        autoLogin({ commit, dispatch }) {
            var user = JSON.parse(localStorage.getItem('nb-succ-api'));
            if (user != null) {
                commit('authUser', { user: user });
            } else {
                dispatch('logout');
            }
        },
        verifyToken({ commit }) {
           // axios.defaults.headers['Authorization'] = `Bearer ${token}`;
            return axios
                .post('user/verifytoken');

        },
        logout({ commit }) {
            commit('clearAuth');
        }

       
        //INHERITANCE
        , inheritanceCreate({ commit }, inheritance) {
            return axios
                .post('inheritances', inheritance)
        }
        , inheritanceSave({ commit }, inheritance) {
            return axios
                .put('inheritances/' + inheritance.inheritanceId, inheritance);
        }
        , inheritanceSaveBase({ commit }, inheritance) {
            return axios
                .put('inheritances/save/' + inheritance.inheritanceId, inheritance);
        }
        , inheritanceNextState({ commit }, inheritanceId) {
            return axios
                .post('inheritances/nextstate/' + inheritanceId);
        }
        , inheritanceJumpOver({ commit }, inheritanceId) {
            return axios
                .post('inheritances/jumpover/' + inheritanceId);
        }

        , inheritanceCheckNextState({ commit }, inheritanceId) {
            return axios
                .post('inheritances/nextstate/check/' + inheritanceId+"?rnd="+Math.random());
        }

        , addperson({ commit }, inheritanceId) {
            return axios
                .post('inheritances/addperson/' + inheritanceId + "?rnd=" + Math.random());
        },
        message({ commit }, id) {
            var me = this;
            axios
                .get('messages/' + id + '?rnd=' + Math.random()).then(function (result) {
                    
                    me.state.message = result.data;
                    
                });

        },
      
        messageSave({ commit }, message) {
            return axios
                .post('messages/', message);
        }
        ,
        inheritanceinformation({ commit }, id) {
            var me = this;
            axios
                .get('inheritances/' + id + '?rnd=' + Math.random()).then(function (result) {
                    for (var i = 0; i < result.data.data.people.length; i++) {
                        result.data.data.people[i].isNew = false;
                    }
                    me.state.inheritance = result.data.data;
                    me.dispatch("inheritanceInformationFlow", me.state.inheritance.inheritanceId).then((result) => me.state.inheritanceFlow = result.data.data);
                });

        }, getVats({ commit }) {
            var me = this;
            axios
                .get('inheritances/vat?rnd=' + Math.random()).then(function (result) {
                    me.state.vats = result.data.data;
                   
                });
        },
  inheritanceCheck({ commit }) {
      return axios.get('inheritances');
        } ,

        operatorList() {
            var me = this;
            axios
                .get('inheritances/operators').then(function (result) {
                    me.state.operators = result.data.data;

                });

        },

        inChargeTo({ dispatch }, { inheritanceId, userId }) {
            axios
                .post('inheritances/incharge/' + inheritanceId, { userId: userId }).then((result) => {
                    this.state.inheritance = result.data.data;
                    this.dispatch("inheritanceInformationFlow", this.state.inheritance.inheritanceId).then((result) => this.state.inheritanceFlow = result.data.data);
                });
        },
        inheritcanceKo({ dispatch }, id) {
            axios
                .post('inheritances/ko/' + id).then((result) => {
                    this.state.inheritance = result.data.data;
                    this.dispatch("inheritanceInformationFlow", this.state.inheritance.inheritanceId).then((result) => this.state.inheritanceFlow = result.data.data);
                });
        },
        inheritcancePrevious({ dispatch }, id) {
            axios
                .post('inheritances/previous/' + id).then((result) => {
                    this.state.inheritance = result.data.data;
                    this.dispatch("inheritanceInformationFlow", this.state.inheritance.inheritanceId).then((result) => this.state.inheritanceFlow = result.data.data);
                });
        },

        inheritancereset({ dispatch }, id) {
    axios.post('inheritances/reset/' + id).then((result) => {
        this.state.inheritance = result.data.data;
        this.dispatch("inheritanceInformationFlow", this.state.inheritance.inheritanceId).then((result) => this.state.inheritanceFlow = result.data.data);
    });
},
        clearInheritance({ dispatch }) {
            this.state.inheritance = null;
        }

        , inheritanceInformationFlow({ commit }, id) {
            return axios
                .get('inheritances/flow/detail/' + id)
        },
        inheritanceFlow({ commit }, state) {
            return axios
                .get('inheritances/flow/' + state)
        },
        inheritanceAttachmentTypes({ commit }) {
            return axios
                .get('attachmenttypes');
        },
        inheritanceNoteCreate({ commit }, note) {
            return axios
                .post('notes', note)
        }, setEnvironment({ commit, dispatch }, isstaging) {
           this.state.isStaging = isstaging
        }

    },
    getters: {
        isStagingArea: state => {
           return state.isStaging
        },
        isLoading: state => {
            return state.loadingState;
        },
        isAuthenticated: state => {
            return state.token !== null;
        }
    }
});
